import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import './TabNavigation.css';

export interface TabConfig {
    key: string;
    label: string;
    route: string;
}

interface TabNavigationProps {
    tabs: TabConfig[];
    className?: string;
}

const TabNavigation: React.FC<TabNavigationProps> = ({ tabs, className = '' }) => {
    const location = useLocation();
    const navigate = useNavigate();

    const getActiveTab = (): string => {
        const currentPath = location.pathname;
        for (const tab of tabs) {
            if (currentPath === tab.route || currentPath.startsWith(tab.route + '/')) {
                return tab.key;
            }
        }
        return '';
    };

    const handleTabClick = (tabKey: string): void => {
        const tab = tabs.find(t => t.key === tabKey);
        if (tab) {
            navigate(tab.route);
        }
    };

    return (
        <div className={`tab-navigation-container ${className}`.trim()}>
            {tabs.map(tab => (
                <button
                    key={tab.key}
                    className={`tab-button ${getActiveTab() === tab.key ? 'active' : ''}`}
                    onClick={() => handleTabClick(tab.key)}
                >
                    {tab.label}
                </button>
            ))}
        </div>
    );
};

export default TabNavigation;